import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

enum CacheKey {
  GetLatestSurveyByTeamId = 'GetLatestSurveyByTeamId',
}

export const useGetLatestSurveyByTeamIdQuery = (teamId: number) => {
  const { getLatestSurveyByTeamId } = useServicesContext();
  return useQuery({
    queryKey: [CacheKey.GetLatestSurveyByTeamId, teamId],
    queryFn: () => getLatestSurveyByTeamId(teamId),
    refetchInterval: 60000,
    enabled: Boolean(teamId)
  });
};
